const latestArticle = {
  "status": "true",
  "message": "取得最新文章",
  "total": "3",
  "ArticleList": [
    {
      "title": "IEKView：乘風破浪AI新賽局來臨！生成式AI掀起典範轉移  IEK產業情報網",
      "author": "IEK產業情報網",
      "url": "https://ieknet.iek.org.tw/iekrpt/rpt_detail.aspx?indu_idno=3&domain=43&rpt_idno=152348682",
      "image": `${require('assets/images/home/news-1.jpg')}`,
      "time": "2023/10/30"
    },
    {
      "title": "AI環境掃描－晶片禁令更新、歐盟法案及拜登行政命令、微軟Copilot全球上市",
      "author": "石立康",
      "url": "https://ieknet.iek.org.tw/iekrpt/rpt_detail.aspx?indu_idno=1&domain=20&rpt_idno=283439235",
      "image": `${require('assets/images/home/news-2.jpg')}`,
      "time": "2024/01/05"
    },
    {
      "title": "AI PC的時代是否已來臨?",
      "author": "石立康",
      "url": "https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=3&domain=44&sld_preid=7444",
      "image": `${require('assets/images/home/news-3.jpg')}`,
      "time": "2024/01/04"
    },
  ]
}

export default latestArticle;